import React from 'react';
import { Card as BaseCard } from 'baseui/card';
import { CardItem } from 'commons-ui';

interface ICardProps {
	label: string;
	img: string;
}

const Card: React.FC<ICardProps> = (props) => {
	const { label, img } = props;
	return (
		<BaseCard
			overrides={{
				Root: {
					style: () => ({
						width: '100%',
						height: '100%',
						borderTopLeftRadius: '20px',
						borderBottomLeftRadius: '20px',
						borderTopRightRadius: '20px',
						borderBottomRightRadius: '20px'
					})
				},
				Body: {
					component: () => <CardItem label={label} img={img} />
				}
			}}
		/>
	);
};

export default Card;
